var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Maintenance100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dark-pink-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#ff3ae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#583aff"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "url(#dark-pink-gradient)",
    d: "M 64.5,3.5 C 69.1785,3.33418 73.8452,3.50085 78.5,4C 80.0441,4.28961 81.3774,4.95627 82.5,6C 77.3333,11.1667 72.1667,16.3333 67,21.5C 67.1667,28.3333 70.6667,31.8333 77.5,32C 82.6667,26.8333 87.8333,21.6667 93,16.5C 99.2718,32.6876 94.4385,44.1876 78.5,51C 73.0897,51.5605 67.7563,51.5605 62.5,51C 48.1667,65.3333 33.8333,79.6667 19.5,94C 6,97.8333 1.16667,93 5,79.5C 19.3333,65.1667 33.6667,50.8333 48,36.5C 44.4934,20.8462 49.9934,9.84625 64.5,3.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Maintenance100);
export default __webpack_public_path__ + "static/media/icons8-maintenance-100.7e594f6eed6a311ab7c63696d0dbdde3.svg";
export { ForwardRef as ReactComponent };